module.exports = __webpack_public_path__ + "img/DSC_0814.79645fd3.jpeg";